<template>
  <div id="workshop">
    <v-fab-transition>
      <v-btn
        color="primary"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">keyboard_arrow_left</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-domain"
                  v-model="companies"
                  :items="uniqueCompanies"
                  label="Companies"
                  @change="getWorkshops"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="search"
                  v-model="workshopNames"
                  :items="uniqueWorkshopNames"
                  label="Workshops"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="isAdminRole">
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-account-multiple"
                  v-model="participants"
                  :items="uniqueParticipants"
                  label="Participants"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-menu
                  v-model="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @input="from = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @input="to = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="drawCharts()" color="info">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container style="width: 100%; max-width: 960px">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <p class="text-center display-1 primary--text">Workshop feedback</p>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Rate</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="rateLoaded"
                      :chartdata="dataCollectionRate"
                      :options="chartOptionsRate"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Content</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="rateContentLoaded"
                      :chartdata="dataCollectionRateContent"
                      :options="chartOptionsRateContent"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Understanding</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="understandingLoaded"
                      :chartdata="dataUnderstanding"
                      :options="chartOptionsUnderstanding"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="4" class="flex-grow-0 flex-shrink-0 ma-1">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text">Recommend</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <pie-chart
                      v-if="recommendLoaded"
                      :chartdata="dataCollectionRecommend"
                      :options="chartOptionsRecommend"
                    ></pie-chart>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Additional feedback or suggestions to help improve
                  service</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-data-table
                :headers="feedbackTableHeader"
                :items="feedbackTableData"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Principles or techniques most useful from
                  session</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-data-table
                :headers="principlesTechniquesTableHeader"
                :items="principlesTechniquesTableData"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Element that should be changed or included</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-data-table
                :headers="elementsToChangeOrIncludeHeader"
                :items="elementsToChangeOrIncludeData"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <!-- <v-flex xs12>
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="12" class="flex-grow-0 ma-2">
            <v-card class="mx-auto">
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-toolbar-title class="black--text"
                  >Tabular data</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
              </v-toolbar>

              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="tableData"
                :search="search"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-flex> -->
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import DefaultLayout from "@/layouts/DefaultLayout";
import SurveyWorkshop from "../classes/SurveyWorkshop";
import PieChart from "@/components/chartjs/PieChart";
import moment from "moment";

export default {
  name: "WorkshopDashboard",
  async created() {
    this.$emit(`update:layout`, DefaultLayout);

    const surveyWorkshop = new SurveyWorkshop(null);
    await surveyWorkshop.getGraphData();
    this.uniqueCompanies = await surveyWorkshop.getUniqueCompanyNames();
    this.uniqueCompanies.unshift("All");

    // this.uniqueWorkshopNames = await surveyWorkshop.getUniqueWorkshopNames();
    this.uniqueWorkshopNames.unshift("All");

    this.uniqueParticipants = await surveyWorkshop.getUniqueTrainer();
    this.uniqueParticipants.unshift("All");
    this.drawCharts();
  },
  components: {
    PieChart,
  },
  data: () => ({
    loading: false,
    graphData: {},
    dataCollectionRate: {},
    chartOptionsRate: {},
    rateLoaded: false,

    dataCollectionRateContent: {},
    chartOptionsRateContent: {},
    rateContentLoaded: false,

    dataUnderstanding: {},
    chartOptionsUnderstanding: {},
    understandingLoaded: false,

    dataCollectionRecommend: {},
    chartOptionsRecommend: {},
    recommendLoaded: false,

    uniqueCompanies: [],
    uniqueParticipants: [],
    uniqueWorkshopNames: [],

    parametersDialog: false,
    loading: false,
    uniqueParticipants: [],
    from: false,
    fromDate: null,
    to: false,
    toDate: null,
    participants: "All",
    service: "All",
    participantsLoaded: false,
    companies: "All",
    workshopNames: "All",
    search: "",
    headers: [
      {
        text: "Trainer",
        value: "trainer",
      },
      { text: "Feedback", value: "feedback" },
    ],
    tableData: [],
    feedbackTableHeader: [
      {
        text: "",
        value: "data",
      },
    ],
    feedbackTableData: [],
    principlesTechniquesTableHeader: [
      {
        text: "",
        value: "data",
      },
    ],
    principlesTechniquesTableData: [],
    elementsToChangeOrIncludeHeader: [
      {
        text: "",
        value: "data",
      },
    ],
    elementsToChangeOrIncludeData: [],
  }),
  methods: {
    async drawCharts() {
      this.parametersDialog = false;
      this.loading = true;
      let filter = null;
      let query = [];

      if (this.companies && this.companies !== "All") {
        query.push({ company: { contains: this.companies } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.workshopNames && this.workshopNames !== "All") {
        query.push({ name: { contains: this.workshopNames } });
      }

      if (this.fromDate && this.toDate) {
        const from = moment(this.fromDate).toISOString();
        const to = moment(this.toDate).toISOString();
        query.push({
          date: {
            between: [from, to],
          },
        });
      }

      if (!this.isAdminRole) {
        Auth.currentAuthenticatedUser().then((user) => {
          filter = {};
          query.push({ participants: { contains: user.attributes.email } });

          query.forEach((q) => {
            Object.assign(filter, q);
          });
        });
      } else {
        if (query.length > 0) {
          filter = {};
          query.forEach((q) => {
            Object.assign(filter, q);
          });
        }
      }

      const surveyWorkshop = new SurveyWorkshop(filter);
      surveyWorkshop.getGraphData().then((result) => {
        this.graphData = result;
        this.rateChart();
        this.rateContentChart();
        this.understandingChart();
        this.recommendChart();

        this.principlesTechniquesTableData = [];
        this.graphData.map((data) => {
          if (data.elementsChangeInclude) {
            this.principlesTechniquesTableData.push({
              data: data.usefulPrinciplesTechniques,
            });
          }
        });

        this.feedbackTableData = [];
        this.graphData.map((data) => {
          if (data.feedback) {
            this.feedbackTableData.push({
              data: data.feedback,
            });
          }
        });

        this.elementsToChangeOrIncludeData = [];
        this.graphData.map((data) => {
          if (data.elementsChangeInclude) {
            this.elementsToChangeOrIncludeData.push({
              data: data.elementsChangeInclude,
            });
          }
        });

        this.tableData = [];
        this.graphData.map((data) => {
          this.tableData.push({
            trainer: data.trainer,
            feedback: data.feedback,
          });
        });
        this.loading = false;
      });
    },
    async getWorkshops() {
      const surveyWorkshop = new SurveyWorkshop(null);
      await surveyWorkshop.getGraphData();
      this.uniqueWorkshopNames = await surveyWorkshop.getUniqueWorkshopNames(this.companies);
      this.uniqueWorkshopNames.unshift("All");
    },
    async rateChart() {
      let dd = {
        excellent: 0,
        verygood: 0,
        good: 0,
        average: 0,
        poor: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.rateWorkshop] = (count[data.rateWorkshop] || 0) + 1;
        return count;
      }, {});
      dd.excellent = d.excellent;
      dd.verygood = d.verygood;
      dd.good = d.good;
      dd.average = d.average;
      dd.poor = d.poor;
      this.rateLoaded = true;
      this.chartOptionsRate = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionRate = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["excellent", "verygood", "good", "average", "poor"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.excellent, dd.verygood, dd.good, dd.average, dd.poor],
          },
        ],
      };
    },
    async rateContentChart() {
      let dd = {
        excellent: 0,
        verygood: 0,
        good: 0,
        average: 0,
        poor: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.workshopContent] = (count[data.workshopContent] || 0) + 1;
        return count;
      }, {});
      dd.excellent = d.excellent;
      dd.verygood = d.verygood;
      dd.good = d.good;
      dd.average = d.average;
      dd.poor = d.poor;
      this.rateContentLoaded = true;
      this.chartOptionsRateContent = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              // console.dir(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionRateContent = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["excellent", "verygood", "good", "average", "poor"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(102, 176, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(230, 85, 13, 0.9)",
              "rgba(198, 40, 40, 0.9)",
              "rgba(227, 118, 194, 0.9)",
            ],
            data: [dd.excellent, dd.verygood, dd.good, dd.average, dd.poor],
          },
        ],
      };
    },
    async understandingChart() {
      let dd = {
        yes: 0,
        dontknow: 0,
        no: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.increaseUnderstanding] =
          (count[data.increaseUnderstanding] || 0) + 1;
        return count;
      }, {});
      dd.yes = d.yes;
      dd.dontknow = d.dontknow;
      dd.no = d.no;
      this.understandingLoaded = true;
      this.chartOptionsUnderstanding = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              // console.dir(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataUnderstanding = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["yes", "don't know", "no"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(198, 40, 40, 0.9)",
            ],
            data: [dd.yes, dd.dontknow, dd.no],
          },
        ],
      };
    },
    async recommendChart() {
      let dd = {
        extremelylikely: 0,
        likely: 0,
        unsure: 0,
        no: 0,
      };
      const d = this.graphData.reduce((count, data) => {
        count[data.recommend] = (count[data.recommend] || 0) + 1;
        return count;
      }, {});
      dd.extremelylikely = d.extremelylikely;
      dd.likely = d.likely;
      dd.unsure = d.unsure;
      dd.no = d.no;
      this.recommendLoaded = true;
      this.chartOptionsRecommend = {
        legend: {
          display: true,
        },
        defaultFontColor: "black",
        hoverBorderWidth: 20,
        tooltips: {
          mode: "index",
          callbacks: {
            afterLabel: function (tooltipItem, data) {
              var sum = data.datasets.reduce((sum, dataset) => {
                return (
                  sum +
                  dataset.data.reduce(function (a, b) {
                    let sumA = parseInt(a) || 0;
                    let sumB = parseInt(b) || 0;
                    return sumA + sumB;
                  }, 0)
                );
              }, 0);
              var percent =
                (data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] /
                  sum) *
                100;
              percent = percent.toFixed(2); // make a nice string
              return data.labels[tooltipItem.index] + ": " + percent + "%";
            },
          },
        },
      };
      this.dataCollectionRecommend = {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["extremelylikely", "likely", "unsure", "no"],
        datasets: [
          {
            label: "Data One",
            // backgroundColor: ["#41B883", "#E46651", "#00D8FF"],
            backgroundColor: [
              "rgba(178, 215, 50, 0.9)",
              "rgba(55, 95, 27, 0.9)",
              "rgba(198, 40, 40, 0.9)",
            ],
            data: [dd.extremelylikely, dd.likely, dd.unsure, dd.no],
          },
        ],
      };
    },
  },
  computed: {
    async isAdminRole() {
      const user = await Auth.currentAuthenticatedUser();
      const awsGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      if (awsGroups) {
        const roles =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        return roles.includes("ADMIN");
      }
    },
  },
};
</script>
<style scoped>
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
.navbar-link {
  text-decoration: none !important;
}
.v-toolbar {
  height: 20px !important;
}
</style>